import React, { useState } from "react";

const AddOns = () => {
  const [agreements, setAgreements] = useState({
    agree1: false,
    agree2: false,
    agree3: false,
    agree4: false,
  });

  const handleCheck = (key) => {
    setAgreements((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const checkboxData = [
    {
      id: "agree1",
      label: "I have read above and agree",
    },
    {
      id: "agree2",
      label:
        "I acknowledge that infection is always possible as a result of obtaining a tattoo, particularly in the event that I do not take proper care of my tattoo and I agree to follow all instructions provided to me, concerning the care of my tattoo while it is healing.",
    },
    {
      id: "agree3",
      label:
        "I do not have Diabetes, Epilepsy, Hepatitis, Hemophilia, HIV-AIDS, Tuberculosis or any other communicable disease, heart condition or take medication, which thins the blood. I am not pregnant or nursing. I am not under the influence of alcohol or drugs.",
    },
    {
      id: "agree4",
      label:
        "I acknowledge that I have truthfully represented to the management or representatives that I am eighteen (18) years of age or older and that the information provided below is true and correct.",
    },
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-primary-marineBlue font-bold text-[1.6rem] md:text-3xl leading-9">
      TATTOO & PIERCING WAIVER
        </h1>
      {checkboxData.map(({ id, label }) => (
        <label
          key={id}
          className="flex items-start gap-3 cursor-pointer text-primary-marineBlue"
        >
          <input
            type="checkbox"
            checked={agreements[id]}
            onChange={() => handleCheck(id)}
            className="mt-1 w-5 h-5 accent-green-600 border border-gray-300"
          />
          <span className="text-sm leading-5 text-black">
            {label}
          </span>
        </label>
      ))}
    </div>
  );
};

export default AddOns;
